import i18n from 'modules/core/lib/i18n'

import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

export interface StatusCounts {
  draft?: number
  pending?: number
  approved?: number
  paid?: number
}

interface UseDataCollectionConfigOptions {
  includeDraft?: boolean
  statusCounts?: StatusCounts
}

const formatLabelWithCount = (label: string, count?: number): string => {
  if (count === undefined) return label
  return `${label} (${count})`
}

export const useDataCollectionConfig = (options: UseDataCollectionConfigOptions = {}) => {
  const { includeDraft = true, statusCounts } = options
  const { dateFilters } = usePageDateFilters()

  const navigationFilters = {
    date: {
      defaultGranularity: 'range' as const,
      defaultValue: {
        from: dateFilters.startDate,
        to: dateFilters.endDate,
      },
      granularity: ['day', 'week', 'month', 'year', 'range'],
      type: 'date-navigator' as const,
    },
  }

  const presets = [
    ...(includeDraft
      ? [
          {
            label: formatLabelWithCount(
              i18n.t('expenses_v2.expense.status.draft'),
              statusCounts?.draft
            ),
            filter: { status: ['draft'] },
          },
        ]
      : []),
    {
      label: formatLabelWithCount(
        i18n.t('expenses_v2.expense.status.pending'),
        statusCounts?.pending
      ),
      filter: { status: ['pending'] },
    },
    {
      label: formatLabelWithCount(
        i18n.t('expenses_v2.expense.status.approved'),
        statusCounts?.approved
      ),
      filter: { status: ['approved'] },
    },
    {
      label: formatLabelWithCount(i18n.t('expenses_v2.expense.status.paid'), statusCounts?.paid),
      filter: { status: ['paid'] },
    },
  ]

  return { navigationFilters, presets }
}
